import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import StatusContainer from "../../../../../components/_utils/CommonStatus/StatusContainer";
import InfoCard from "../../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import { formatAccountNumber } from "../../../../../components/_utils/FormatAccountNumber";
import { viewAccountDetail } from "../../../../../redux/features/accounts/ReimburseAccount";
import { setHideBreadCrumb } from "../../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import {
  beneLookUp,
  resetInEdit,
  resetVerification,
} from "../../../../../redux/features/verifyPAN/verifyPAN";
import { GlobalConfiguration } from "../../../../../utils/configurationProvider";

const ReimbursementPanEditSucess = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { id } = useParams();
  const updatedFields = location?.state?.updatedFields || [];
  const [previousAssociated, setPreviousAssociated] = useState(0);

  const [currentAccountDetails, setCurrentAccountDetails] = useState({
    id: "",
    name: "",
    bank_name: "",
    bank_acc_no: "",
    ifsc_code: "",
    category: "",
    pan: "",
    labels: [],
  });

  useEffect(() => {
    dispatch(resetVerification());
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  useEffect(() => {
    const fetchPANviewAccountDetailData = async () => {
      let response = await dispatch(viewAccountDetail({ id }));
      if (response?.error?.message === "Request failed with status code 404") {
        navigate("*");
      }
    };
    fetchPANviewAccountDetailData();
  }, [dispatch, id, navigate]);

  useEffect(() => {
    const storedValue = localStorage.getItem("haveAssociated");
    if (storedValue !== null) {
      setPreviousAssociated(JSON.parse(storedValue));
    }
  }, []);

  const { beneLookData } = useSelector((state) => state.verify);

  const { viewAccountDetailData, viewAccountDetailLoading } = useSelector(
    (state) => state.ReimburseAccount,
  );

  const beneficiaryAccount = useMemo(
    () => viewAccountDetailData?.reimbursement_accounts[0] || {},
    [viewAccountDetailData],
  );

  useEffect(() => {
    if (
      beneficiaryAccount &&
      Object.keys(beneficiaryAccount).length >
        GlobalConfiguration.lengthCheckZero
    ) {
      const {
        id,
        name,
        bank_name,
        bank_acc_no,
        ifsc_code,
        category,
        pan_no,
        labels,
      } = beneficiaryAccount;
      setCurrentAccountDetails({
        id,
        name,
        bank_name,
        bank_acc_no,
        ifsc_code,
        category,
        pan: pan_no,
        labels: labels || [],
      });
    }
  }, [beneficiaryAccount]);

  const createTxn = () => {
    navigate(
      "/reimbursement_transaction_dashboard/create_reimbursement_transactions",
      {
        state: currentAccountDetails,
      },
    );
  };
  const createAccount = () => {
    navigate("/reimbursement_account_dashboard/create_reimbursement_account", {
      state: currentAccountDetails,
    });
  };
  const viewDetailsHandler = () => {
    navigate(
      `/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/${id}`,
    );
  };
  const dashboardHandler = () => {
    navigate("/reimbursement_account_dashboard");
  };

  let haveApproved = beneLookData?.beneficiary_accounts?.find((val) => {
    return val?.approval_status === "approved";
  });
  let havePending = beneLookData?.beneficiary_accounts?.find((val) => {
    return val?.approval_status === "pending" && val?.id !== id;
  });

  useEffect(() => {
    if (!viewAccountDetailLoading && viewAccountDetailData) {
      dispatch(
        beneLookUp({
          pan_number: viewAccountDetailData?.reimbursement_accounts[0]?.pan_no,
        }),
      );
    }
    return () => {
      dispatch(resetInEdit());
    };
  }, [dispatch, viewAccountDetailLoading, viewAccountDetailData]);

  const buttonRows = [
    [
      {
        btnText: "Create account",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: "https://q2pay.in/new_assets/common/create_flow/create_new_account.svg",
        handleFunction: createAccount,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
      {
        btnText: "Create transaction",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: "https://q2pay.in/new_assets/common/settings/add_button_white.svg",
        handleFunction: createTxn,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
      {
        btnText: "View details",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: "https://q2pay.in/new_assets/common/create_flow/view_details.svg",
        handleFunction: viewDetailsHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: "https://q2pay.in/new_assets/common/dashboard/dashboard.svg",
        handleFunction: dashboardHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "white",
      },
    ],
  ];

  const shouldShowAssociatedTab =
    previousAssociated === false &&
    (haveApproved !== undefined || havePending !== undefined);

  const approvedAccounts =
    beneLookData?.beneficiary_accounts?.filter(
      (val) => val?.approval_status === "approved",
    ) || [];

  const pendingAccounts =
    beneLookData?.beneficiary_accounts?.filter(
      (val) => val?.approval_status === "pending" && val?.id !== id,
    ) || [];

  const fieldsToShow =
    updatedFields.length > GlobalConfiguration.lengthCheckZero
      ? updatedFields
      : ["pan_no", "gstin_detail"];

  const panGstFieldConfig = {
    pan_no: {
      leftSubTitle: "PAN number",
      getTitle: (acc) => acc?.pan_no,
    },
    gstin_detail: {
      leftSubTitle: "GSTIN (optional)",
      getTitle: (acc) => acc?.gstin_detail,
    },
  };

  // Main title: sirf GST update pe "GST number updated successfully.", sirf PAN pe "PAN number updated successfully."
  const onlyGstUpdated =
    updatedFields.length === 1 && updatedFields[0] === "gstin_detail";
  const onlyPanUpdated =
    updatedFields.length === 1 && updatedFields[0] === "pan_no";
  const getPanGstSuccessTitle = () => {
    if (onlyGstUpdated) return "GST number updated successfully.";
    if (onlyPanUpdated) return "PAN number updated successfully.";
    return "PAN and GST number updated successfully.";
  };

  const renderPanGstCards = () => {
    return fieldsToShow
      .filter((key) => panGstFieldConfig[key])
      .filter(
        (key) => key !== "gstin_detail" || beneficiaryAccount?.gstin_detail,
      )
      .map((key) => {
        const config = panGstFieldConfig[key];
        const title = config.getTitle(beneficiaryAccount);
        if (key === "gstin_detail" && !title) return null;
        return (
          <InfoCard
            key={key}
            bgColor="var(--positive-card)"
            rows={[
              {
                leftTitle: title || "Not Given",
                leftSubTitle: config.leftSubTitle,
              },
            ]}
          />
        );
      });
  };

  return (
    <>
      <StatusContainer
        isLoading={viewAccountDetailLoading}
        status="success"
        hoverOption="white"
        title={getPanGstSuccessTitle()}
        buttonRows={buttonRows}
      >
        <TabsWeapperSection title="Account details">
          <>{renderPanGstCards()}</>
        </TabsWeapperSection>
        {shouldShowAssociatedTab && (
          <TabsWeapperSection title="Accounts Associated to PAN">
            <>
              {haveApproved &&
                approvedAccounts.length >
                  GlobalConfiguration.lengthCheckZero && (
                  <>
                    {approvedAccounts.map((val, index) => (
                      <InfoCard
                        key={val?.id || index}
                        bgColor="var(--positive-card)"
                        header={true}
                        borderColor="var(--positive-bg)"
                        rightHeaderText="Approved account"
                        rightHeaderTextColor="var(--text-secondary)"
                        leftHeaderText={val?.name?.toLowerCase()}
                        rows={[
                          {
                            leftTitle: formatAccountNumber(val?.bank_acc_no),
                            leftSubTitle: "Bank account number",
                            ifsc: val?.ifsc_code,
                          },
                        ]}
                      />
                    ))}
                  </>
                )}
              {havePending &&
                pendingAccounts.length >
                  GlobalConfiguration.lengthCheckZero && (
                  <>
                    {pendingAccounts.map((val, index) => (
                      <InfoCard
                        key={val?.id || index}
                        bgColor="var(--positive-card)"
                        header={true}
                        borderColor="var(--positive-bg)"
                        rightHeaderText="Pending account"
                        rightHeaderTextColor="var(--text-secondary)"
                        leftHeaderText={val?.name?.toLowerCase()}
                        rows={[
                          {
                            leftTitle: formatAccountNumber(val?.bank_acc_no),
                            leftSubTitle: "Bank account number",
                            ifsc: val?.ifsc_code,
                          },
                        ]}
                      />
                    ))}
                  </>
                )}
              {!haveApproved &&
                !havePending &&
                (!beneLookData?.beneficiary_accounts ||
                  beneLookData.beneficiary_accounts.length ===
                    GlobalConfiguration.lengthCheckZero) && (
                  <InfoCard
                    bgColor="var(--positive-card)"
                    rows={[
                      {
                        leftTitle:
                          "  No associated accounts found for the PAN details provided",
                        leftSubTitle:
                          " There are no existing accounts that are associated with the PAN details provided.",
                      },
                    ]}
                  />
                )}
            </>
          </TabsWeapperSection>
        )}
      </StatusContainer>
    </>
  );
};

export default ReimbursementPanEditSucess;
